

import React, { useEffect } from 'react';
import styled from 'styled-components';

import { Icon } from '../../../../../../ui-kit';

import { PlayerComponent } from '../../../../../Player';
import { ElevateVideoPlaceholder } from '../../../ImagePlaceholder';

import { useDataContext } from '../../../../contexts/DataAdapterContext';



const UUID_REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;











const PlayerPlaceholder = styled.div`
  height: 500px;
  display: flex;
  justify-content: center;

  @media only screen and (max-width: 639px) {
    height: 300px;
  }
`;

const ShootstaPlayer = (props) => {
  const { video } = props;
  const { assetId } = video;

  const { shootstaPlayerProps } = useDataContext();
  const {
    assetDetails = {},
    fetchPublicAsset,
    ...other
  } = shootstaPlayerProps;

  useEffect(() => {
    if (typeof assetId === 'string' && UUID_REGEX.test(assetId) && typeof fetchPublicAsset === 'function') {
      fetchPublicAsset(assetId);
    }
  }, [assetId, fetchPublicAsset]);

  if (assetDetails.isLoading) {
    return (
      <PlayerPlaceholder>
        <Icon name="shootstagrad" size={40} color="black" spin />
      </PlayerPlaceholder>);

  }

  return (
    <>
      {assetDetails.data ?
      <PlayerComponent
        asset={assetDetails.data}
        assetId={assetId}
        {...other} /> :

      <ElevateVideoPlaceholder />}
    </>);

};

export default ShootstaPlayer;